const index = process.env.REACT_APP_PROJECT_INDEX || undefined;
const essay = process.env.REACT_APP_SHOW_ESSAY || false;
export const hasDifferentLayout = () => {
  if (index && index === "fes") {
    return true;
  } else if (index && index === "climate") {
    return true;
  } else if (index && index === "neolib") {
    return true;
  } else {
    return false;
  }
};

export const isFes = () => {
  if (index && index === "fes") {
    return true;
  } else {
    return false;
  }
};

export const showEssay = () => {
  return essay
};
